// Texto de um toast: errorCode traduzido de errors.json (fallback genérico) e título do servidor quando existir.
import type { TFunction } from 'i18next';

import type { ToastItem } from '../lib/toast/toastStore';

export function describeToast(
  toast: ToastItem,
  t: TFunction<['common', 'errors']>,
): { title: string; description: string } {
  if (toast.errorCode === null) {
    return { title: t('common:state.error'), description: t('errors:generic.network') };
  }
  return {
    title: toast.serverTitle ?? t('common:state.error'),
    description: t(`errors:codes.${toast.errorCode}`, {
      defaultValue: t('errors:generic.unknown', { errorCode: toast.errorCode }),
    }),
  };
}
